import { Stack } from '@mui/material'
import { useEffect } from 'react'

interface ConfigLayoutProps {
  title: string
  header?: React.ReactNode
  children?: React.ReactNode
  fullWidth?: boolean
}

const ConfigLayout = ({
  title = '',
  children,
  header,
  fullWidth = false,
}: ConfigLayoutProps) => {
  useEffect(() => {
    document.title = `${title} | Cisgenics Admin`
  }, [title])

  return (
    <Stack direction={'row'}>
      <Stack
        width={'calc(100% - 76px)'}
        minHeight="100vh"
        bgcolor="background.default"
        sx={{
          marginLeft: '76px',
        }}
      >
        {header}
        <Stack sx={{ padding: fullWidth ? '0px' : '12px 12px', flexGrow: 1 }}>
          {children}
        </Stack>
      </Stack>
    </Stack>
  )
}

export default ConfigLayout
